import {
  Component,
  ViewEncapsulation,
  OnInit, OnDestroy
} from '@angular/core';
import {
  State
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  GridDataResult, SelectionEvent,
} from '@progress/kendo-angular-grid';
import {
  BehaviorSubject,
  Observable, Subject
  , Subscription
} from 'rxjs';
import {
  ClientsService
} from './clients.service';
import {
  FormControl
} from '@angular/forms';
import {Router} from '@angular/router';
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {SearchContext} from '../services/search/search-context';
import {ClientDialogComponent} from '../accounts/detail/components/client-dialog/client-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ApiService} from '../services/api';
import {UserContext} from '../services/user-context';



@Component({
  selector: 'app-clients',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'clients.template.html'
})
export class ClientsComponent implements OnInit, OnDestroy {
  public view: Observable<GridDataResult>;
  public subscription: Subscription;
  public state: State = {
    skip: 0,
    take: 10
  };

  private searchSubscription: Subscription;

  loading = false;

  constructor(
    private router: Router,
    private service: ClientsService,
    public dialog: MatDialog,
    private userContext: UserContext,
    private snackBar: MatSnackBar,
    private api: ApiService,
    private searchContext: SearchContext) {

    this.view = service;
    this.subscription = service.subscription;
  }

  public ngOnInit(): void {
    this.searchSubscription = this.searchContext.searchObserver.pipe(debounceTime(400), distinctUntilChanged()).subscribe((term) => {
        if ((term || "").length >= 3 || (term || "").length === 0) {
          this.state.skip = 0;
          this.getClients();
        }
      });
  }

  public ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
    this.service.clear();
  }

  public selectedRow(event: SelectionEvent) {
    this.router.navigate(['', 'clients', `${event.selectedRows[0].dataItem._id}`]);
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.getClients();
  }

  public getClients() {
    this.loading = true;
    const page = this.state.skip / this.state.take + 1;
    const limit = this.state.take;

    this.service.getList(page, limit, () => {
      this.loading = false;
    }, this.searchContext.searchObserver.value || '');
  }

  public addClient(): void {
    const dialogRef = this.dialog.open(ClientDialogComponent, {
      width: '750px',
    });

    dialogRef.afterClosed().subscribe(client => {
      if ( client ) {
        this.api.post<any>(`/account/${this.userContext.account.id}/client`, client).subscribe( result => {
          //console.log("Updated client respoonse: " + JSON.stringify(result));
          this.getClients();
          this.snackBar.open('Client added.', null, {
            duration: 2000
          });
        }, (error) => {
          this.snackBar.open(`Error updating information: ${error}`, null, {
            duration: 2000
          });
        });
      }
    });
  }

}
